var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.firm}},[_vm._v("开始推流")]),_c('iframe',{attrs:{"id":"share","src":"https://ztxrtc.zhaotx.cn/shareStream?v=2024130","frameborder":"0","align":"middle","width":"0px","height":"0px","scrolling":"no","allow":"microphone; camera; display-capture;"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }